import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FuseSplashScreenService} from '@fuse/services/splash-screen.service';
import {TranslateService} from '@ngx-translate/core';
import {NotificationsService} from 'angular2-notifications';
import Utils from 'app/utils/utils';
import * as FileSaver from 'file-saver';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class FileDownloaderService {

    constructor(
        private fuseSplashScreenService: FuseSplashScreenService,
        private httpClient: HttpClient,
        private notificationsService: NotificationsService,
        private translateService: TranslateService,
    ) {
    }

    public downloadDataAsBase64(url: string): Observable<string> {
        return Utils.downloadDataAsBase64(this.httpClient, url);
    }

    public downloadFile(url: string, fileName: string = null): void {
        this.fuseSplashScreenService.show();
        this.httpClient.get(url, {responseType: 'blob', observe: 'response'}).subscribe(
            (res) => {
                this.fuseSplashScreenService.hide();
                this.notificationsService.success('Stažení souboru bylo úspěšné', null, {timeOut: 2000});
                if (fileName == null) {
                    FileSaver.saveAs(res.body, this.getFilenameFromContentDisposition(res.headers.get('content-disposition')));
                } else {
                    FileSaver.saveAs(res.body, fileName);
                }
            },
            (err) => {
                this.fuseSplashScreenService.hide();
                this.notificationsService.error('Chyba při stahování souboru', this.translateService.instant(`HTTP.${err.status}`), {timeOut: 10000});
            });
    }

    private getFilenameFromContentDisposition(val: string): string {
        const defaultFilename = 'download';
        if (val == null || val.trim() === '') {
            return defaultFilename;
        }

        let filename = '';
        const chunks: string[] = val.split(';').map(m => m.trim()).filter(f => f.startsWith('filename'));
        for (const chunk of chunks) {
            if (chunk.startsWith('filename=')) {
                filename = chunk.substring(9).replace('"', '');
            }
            if (chunk.toLowerCase().startsWith('filename*=UTF-8\'\''.toLowerCase())) {
                // substring >> filename*=UTF-8''
                filename = decodeURI(chunk.substring(17));
                break;
            }
        }
        if (filename.trim() === '') {
            filename = defaultFilename;
        }

        return filename;
    }
}
